/* ═══════════════════════════════════════════════════════════════════════
   ADD-ON LINES CAN NEVER STAND ALONE

   The $19.99 real-stitchout proof (and the free-approval line) are add-ons to
   a patch — they only make sense attached to one. If the customer removes the
   last patch and an add-on is all that is left, the cart is not "a cart with
   one item", it is an empty cart with a stray charge in it. This clears the
   remainder so they land on the normal empty-cart page.

   Runs after ANY /cart/ mutation (the theme uses fetch for cart updates) and
   once on load, so it covers the cart page, the drawer, and AJAX removals.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  var busy = false;

  function addonIds() {
    return (window.NP_ADDON_PRODUCT_IDS || []).filter(function (n) { return !!n; });
  }

  function check() {
    var ids = addonIds();
    if (busy || !ids.length) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var onlyAddons = cart.items.every(function (it) {
          return ids.indexOf(it.product_id) !== -1;
        });
        if (!onlyAddons) return;
        busy = true;
        try { console.log('[np] add-on left alone in cart — clearing', cart.items.length, 'line(s)'); } catch (e) {}
        return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
          .then(function () {
            /* the cart page has to repaint from the server; a drawer can just
               be told the cart changed */
            if (/\/cart/.test(location.pathname)) location.reload();
            else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          });
      })
      .catch(function () { busy = false; });
  }

  /* any cart mutation is a reason to re-check — including the ones the theme
     fires itself when a line is removed */
  var of_ = window.fetch;
  window.fetch = function (u, o) {
    var url = (typeof u === 'string') ? u : (u && u.url) || '';
    var p = of_.apply(this, arguments);
    if (/\/cart\/(change|update|add|clear)/.test(url) && !/clear/.test(url)) {
      p.then(function () { setTimeout(check, 120); }).catch(function () {});
    }
    return p;
  };
  var OX = window.XMLHttpRequest;
  if (OX) {
    var open_ = OX.prototype.open;
    OX.prototype.open = function (m, url) {
      this.__npCart = /\/cart\/(change|update|add)/.test(String(url || ''));
      return open_.apply(this, arguments);
    };
    var send_ = OX.prototype.send;
    OX.prototype.send = function () {
      if (this.__npCart) this.addEventListener('load', function () { setTimeout(check, 120); });
      return send_.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
